export function isEditableTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  return Boolean(target.closest('input, textarea, select, [contenteditable="true"]'));
}

export function isActionTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  return Boolean(target.closest('a, button, input, textarea, select, [contenteditable="true"]'));
}

/** Focus the front panel's primary control instead of no-op navigating to the current path. */
export function focusFrontPanelAction() {
  const body = document.querySelector('.spatial-panel[data-front="true"] .spatial-panel-body');
  if (!(body instanceof HTMLElement)) return;
  const hosted = body.querySelector<HTMLElement>('[data-spatial-cta] button, [data-spatial-cta] a');
  if (hosted) {
    hosted.focus();
    return;
  }
  const next = [...body.querySelectorAll<HTMLElement>('button:not([disabled]), a[href]')].find(
    (el) => !el.closest('.spatial-row'),
  );
  next?.focus();
}

export function frontPanelActionLabel(): string {
  const body = document.querySelector('.spatial-panel[data-front="true"] .spatial-panel-body');
  if (!(body instanceof HTMLElement)) return '';
  const hosted = body.querySelector<HTMLElement>('[data-spatial-cta] button, [data-spatial-cta] a');
  const el =
    hosted ??
    [...body.querySelectorAll<HTMLElement>('button:not([disabled]), a[href]')].find(
      (node) => !node.closest('.spatial-row') && !node.closest('.spatial-command'),
    );
  return el?.textContent?.replace(/\s+/g, ' ').trim() ?? '';
}
